<template lang="pug">
div
  PageTitle
  v-card
    v-alert(type='error' :value='true' v-if='competition === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}
  v-card.mb-5(:raised='isModified')
    //- 存檔工具列
    v-toolbar(flat style={ transform: `none` })
      ToolbarSaveContent(:show='isModified && !isAutoSubmit' @submit='submit' @cancel='discard' :loading='isSaving' :disabled='isLoading')
      v-spacer
      v-menu(v-model='menu' :close-on-content-click='false' :nudge-width='200' offset-x)
        v-tooltip(bottom slot='activator')
          v-btn(flat icon color='primary' :disabled='isLoading' slot='activator'): v-icon fas fa-file-import
          span 匯入自報名表單...
        v-card(max-width='300')
          v-card-text
            v-subheader.pa-0 匯入自報名表單
            v-select(label='屆' :disabled='isImporting' :items='periodList' v-model.number='importPeroid')
            v-select(label='階段' :disabled='isImporting' :items='levelList'  v-model.number='importLevel')
            .mt-1: small.grey--text 從報名表單匯入資料，將會覆蓋#[b.red--text 所有組別]的賽況資訊
          v-divider
          v-card-actions
            v-spacer
            v-btn(flat :disabled='isImporting' @click='menu = false') {{ $t('cancel') }}
            v-btn(color='primary' :loading='isImporting' flat @click='fetchImport') 匯入

      v-menu(bottom right :disabled='isLoading')
        v-btn(slot='activator' icon)
          v-icon more_vert
        v-list(subheader)
          v-subheader 批量設定狀態
          v-list-tile(@click='setAllStatus(groupId, i)' v-for='i in [1, 3]' :key='i')
            v-list-tile-avatar: v-icon.mr-2(:color='competitionStatusTable[i].color') arrow_right
            v-list-tile-content 全部{{ competitionStatusTable[i].name }}
          v-divider
          v-subheader 重新排序
          v-list-tile(@click='sortByTime(groupId, false)')
            v-list-tile-avatar: v-icon fas fa-clock
            v-list-tile-content 報名時間升序
            v-list-tile-action: v-icon(small) fas fa-sort-numeric-down
          v-list-tile(@click='sortByTime(groupId)')
            v-list-tile-avatar
            v-list-tile-content 報名時間降序
            v-list-tile-action: v-icon(small) fas fa-sort-numeric-up
          v-list-tile(@click='randomSort(groupId)')
            v-list-tile-avatar: v-icon fas fa-random
            v-list-tile-content 隨機亂序
          v-divider
          v-subheader 編輯模式
          v-list-tile(@click='toggleIsFreeEdit')
            v-list-tile-avatar
              ReadonlyCheckbox(:value='isFreeEdit' :disabled='isAutoSubmit')
            v-list-tile-content
              v-list-tile-title 自由編輯模式: {{ isFreeEdit ? `開啟` : `關閉` }}
              v-list-tile-sub-title 可手動新增、刪除或編輯賽況項目
          v-list-tile(@click='toggleIsAutoSubmit')
            v-list-tile-avatar
              ReadonlyCheckbox(:value='isAutoSubmit' :disabled='isFreeEdit')
            v-list-tile-content
              v-list-tile-title 自動發佈: {{ isAutoSubmit ? `開啟` : `關閉` }}
              v-list-tile-sub-title 立即發佈所有變更

    //- 組別選單
    v-tabs(slider-color='primary' v-if='groupList' v-model='selectedTab' show-arrows)
      v-tab(v-for='(i, index) in groupList' :key='index' :disabled='isLoading') {{ convertGroupText(i) }}

    //- 批次設定工具列
    v-card-text.pb-0(v-if='competition && checkedItemCount !== null')
      .multiple-selection-bar
        v-scale-transition.transition-group(group leave-absolute)
          v-btn.mr-2.primary--text(depressed small @click.native.stop='isFreeEdit = false' v-if='isFreeEdit && !isModified' key='free-edit' :disabled='isLoading')
            | #[v-icon.mr-2(small) close] 關閉自由編輯模式
          v-btn.mr-2.primary--text(depressed small @click.native.stop='isAutoSubmit = false' v-if='isAutoSubmit' key='auto-submit' :disabled='isLoading')
            | #[v-icon.mr-2(small) close] 關閉自動發佈
          span.mr-1(v-if='isSomeMultipleChecked' key='stauts-text')
            | 已選{{ checkedItemCount === -1 ? `所有` : ` ${checkedItemCount} 個` }}項目
          v-btn(depressed small @click.native.stop='multipleCheckList = []' v-if='isSomeMultipleChecked' key='cancel-select') 取消選取
          v-btn.mr-4(depressed small @click.native.stop='checkItem(true)' v-if='checkedItemCount !== -1' key='select-all') 全選
          v-btn.btn(
            depressed small round
            @click.native.stop='setStatus(groupId, multipleCheckList.map((_, index) => _ && index).filter(_ => _ !== false), +index)'
            v-for='(i, index) in competitionStatusTable'
            v-if='isSomeMultipleChecked && (+index !== 2 || checkedItemCount === 1)'
            :key='i.name'
            :disabled='isLoading'
          )
            v-icon.mr-1(:color='i.color' left) arrow_right
            span.mr-1 {{ i.name }}
          v-btn.ml-4(depressed small color='error' @click.native.stop='deleteCheckedItem()' v-if='isSomeMultipleChecked && isFreeEdit' key='del-some') 刪除所選項目

    Loader(:show='competition === null')

    //- 順序列表
    v-list(subheader v-for='(g, index) in groupList' :key='index' v-if='competition && index === selectedTab' ref='list')
      v-subheader {{ convertGroupText(g) }}
      draggable(v-model='competition[g]' @update='onDraggableUpdate' handle='.handle')
        transition-group(:name='!isFreeEdit ? `list`: ``')
          //- 各個項目
          v-list-tile.list-item(v-for='(i, index) in competition[g]' :key='!isFreeEdit ? i.song + i.timestamp : index' avatar :class='{ active: multipleCheckList[index], handle: !isMobile }')
            v-list-tile-action.handle(:style='isMobile && `min-width: 30px`' v-if='isMobile'): v-icon(color='grey' @click.native.stop) dehaze
            v-list-tile-action(v-if='!isMobile && isFreeEdit')
              v-checkbox(v-model='multipleCheckList[index]' color='primary')
            v-list-tile-avatar.number(color='primary' v-if='!isFreeEdit' size='30' :style='isMobile && `min-width: 42px`') {{ index + 1 }}
            v-list-tile-avatar(v-else)
              v-btn(color='red' icon flat @click='removeItem(g, index)'): v-icon(small) clear
            //- 普通顯示模式
            v-list-tile-content(v-if='!isFreeEdit' @click.stop='clickItem(index)')
              v-list-tile-title {{ i.song }}
              v-list-tile-sub-title {{ i.name }}

            //- 自由編輯模式
            v-list-tile-content(v-else)
              v-list-tile-title
                input.full(placeholder='歌曲' v-model.trim='competition[g][index].song')
              v-list-tile-sub-title
                input.auto(placeholder='報名人' v-model.trim='competition[g][index].name')
            //- 狀態按鈕
            v-list-tile-action
              div
                v-menu(offset-y @click.native.stop)
                  v-btn.px-3.white--text(depressed round :color='competitionStatusTable[i.status].color' slot='activator' :disabled='isLoading' small)
                    v-icon.mr-2(left size=12 v-if='competitionStatusTable[i.status].icon') {{ competitionStatusTable[i.status].icon }}
                    | {{ competitionStatusTable[i.status].name }}
                  v-list
                    template(v-for='(s, sIndex) in competitionStatusTable')
                      v-list-tile(@click='setStatus(g, [index], sIndex)' :key='sIndex')
                        v-list-tile-avatar: v-icon(size=16 :color='s.color' v-if='s.icon') {{ s.icon }}
                        v-list-tile-title {{ s.name }}
                      v-divider(v-if='+sIndex === 3' :key='`divider${sIndex}`')

      v-list-tile(v-if='isFreeEdit')
        v-list-tile-action
        v-list-tile-content
          v-btn(color='primary' @click='addItem(g)') #[v-icon(left) add] 新增
  DebugCodeBlock(:value='competition')
  SnackbarSuccess(ref='successSnackbar')

  //- 針對自動發佈的發佈中提示 snackbar
  v-snackbar(bottom right :timeout='0' :value='isSaving' v-if='isAutoSubmit')
    v-progress-circular.mr-3(indeterminate size=24 width=3)
    span 自動發佈中...
    v-spacer
</template>

<script>
import apis from '@/assets/js/apis'

import { formStatus } from '@/mixins/formStatus'
import draggable from 'vuedraggable'
import Loader from '@/components/Loader.vue'
import ToolbarSaveContent from '@/components/ToolbarSaveContent.vue'
import SnackbarSuccess from '@/components/SnackbarSuccess.vue'
import PageTitle from '@/components/PageTitle.vue'
import ReadonlyCheckbox from '@/components/ReadonlyCheckbox.vue'

export default {
  name: 'Competition',
  metaInfo () {
    return {
      title: this.$t('賽況資訊'),
    }
  },
  data () {
    return {
      selectedTab: 0,
      competition: null,
      menu: false,
      isImporting: false,
      isFetching: false,
      importPeroid: null,
      importLevel: null,
      isFreeEdit: false,
      isAutoSubmit: false,
      selectedGroup: 0,
      multipleCheckList: [],
      //
      isShiftPin: false, // 是否按著 shift 鍵
      isCtrlPin: false, // 是否按著 ctrl/command 鍵
      pinOrigin: null, // 多選的起點
    }
  },
  mounted () {
    this.fetch()
    this.setImportField()
    this.setBodyClick()
    this.setOnKeyEvent()
  },
  methods: {
    setStatus (groupId, indexList = [], status) {
      // 檢查是否有其他的進行中項目
      if (+status === 2) { // 若欲設定的狀態是`進行中`
        this.groupList.forEach(g => { // 迭代所有組別
          this.competition[g].forEach((item, index) => { // 迭代該組別下的所有項目
            if (item.status === 2) { this.competition[g][index].status = 1 } // 若找到`進行中`的項目則設為`結束`
          })
        })
      }

      // 設定狀態
      const items = this.competition[groupId]
      indexList.forEach((index) => { items[index].status = +status })
    },
    randomSort (groupId) {
      const items = this.competition[groupId]
      this.$set(this.competition, groupId, items.sort(() => Math.random() > 0.5 ? -1 : 1))
    },
    sortByTime (groupId, desc = true) {
      const items = this.competition[groupId]
      this.$set(this.competition, groupId, items.sort((a, b) => {
        const at = a.timestamp || 0
        const bt = b.timestamp || 0
        return desc ? bt - at : at - bt
      }))
    },
    setAllStatus (groupId, status = 1) {
      const items = this.competition[groupId]
      this.competition[groupId] = items.map(item => {
        item.status = status
        return item
      })
    },
    addItem (group) {
      const item = { status: 3, level: 1, timestamp: +new Date() };
      ['school', 'lineId', 'phone', 'song', 'email', 'name'].forEach(key => { item[key] = '' })
      this.competition[group].push(item)
    },
    removeItem (group, index) {
      this.competition[group].splice(index, 1)
    },
    async fetch () {
      this.isFetching = true
      try {
        this.competition = await apis.competition.get(this.token) || null
        this.clearIsModified()
        this.setImportField()
        this.$nextTick(() => { this.isFetching = false })
      } catch (e) {
        this.error = e
        this.competition = false
      }
    },
    async submit () {
      this.reduceCompetiiton() // 在送出前過濾個資
      const body = { ...this.competition }
      this.isSaving = true
      this.clearError()
      try {
        await apis.competition.put(body, this.token)
        this.isSaving = false
        this.$refs.successSnackbar.show('成功發佈賽況資訊')
        this.fetch()
        this.clearIsModified()
      } catch (e) {
        this.isSaveFailed = true
        this.isSaving = false
        this.error = e
      }
    },
    async fetchImport () {
      const level = this.importLevel
      const period = this.importPeroid
      const params = { period, level }
      this.isImporting = true
      try {
        const data = await apis.competition.getImport(params, this.token)
        this.competition = data || []
        this.isImporting = false
        this.menu = false
      } catch (e) {
        this.isImporting = false
        this.error = e
      }
    },
    setImportField () {
      if (this.periodList.length === 1) {
        this.importPeroid = this.periodList[0]
      } else if (this.periodList.length > 1) {
        this.importPeroid = Math.max(...this.periodList)
      }

      if (this.levelList.length === 1) {
        this.importLevel = this.levelList[0].value
      } else if (this.levelList.length > 1) {
        this.importLevel = Math.max(...this.levelList.map(v => v.value))
      }
    },
    discard () {
      this.competition = null
      this.fetch()
      this.clearIsModified()
    },
    toggleIsFreeEdit () {
      this.isAutoSubmit = false
      this.isFreeEdit = !this.isFreeEdit
    },
    toggleIsAutoSubmit () {
      this.isFreeEdit = false
      this.isAutoSubmit = !this.isAutoSubmit
    },
    checkItem (index = true, mulit = false) {
      if (index === true || index === false) { // 全選或全不選
        const items = this.competition[this.groupId]
        this.multipleCheckList = items.map(_ => index)
      } else { // 選一個
        if (!mulit) this.checkItem(false)
        this.$set(this.multipleCheckList, index, !this.multipleCheckList[index])
      }
    },
    deleteCheckedItem () {
      const items = this.competition[this.groupId]
      this.competition[this.groupId] = items.map((_, index) => {
        return this.multipleCheckList[index] ? null : _
      }).filter(_ => _ !== null)
      this.multipleCheckList = []
    },
    reduceCompetiiton () {
      Object.keys(this.competition).filter(_ => !['isPlaying', 'timestamp'].some(v => _ === v)).forEach(group => {
        this.competition[group] = this.competition[group].map(_ => {
          return { timestamp: _.timestamp, song: _.song, name: _.name, status: _.status }
        })
      })
    },
    setBodyClick () {
      const handler = e => {
        const { list } = this.$refs
        if (list && !list.every(({ $el }) => $el.contains(e.target))) {
          this.checkItem(false)
          this.pinOrigin = null
        }
      }
      document.addEventListener('click', handler)

      this.$once('hook:beforeDestroy', () => document.removeEventListener('click', handler))
    },
    setOnKeyEvent () {
      const ctrlOrCommandKey = ['Meta', 'Control']
      const keyDown = code => {
        if (code.keyCode === 16 && code.shiftKey) this.isShiftPin = true
        else if (ctrlOrCommandKey.some(_ => _ === code.key)) this.isCtrlPin = true
      }
      const keyUp = code => {
        if (code.keyCode === 16) this.isShiftPin = false
        else if (ctrlOrCommandKey.some(_ => _ === code.key)) this.isCtrlPin = false
      }
      window.addEventListener('keydown', keyDown)
      window.addEventListener('keyup', keyUp)

      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('keydown', keyDown)
        window.removeEventListener('keyup', keyUp)
      })
    },
    // 點擊項目
    clickItem (index) {
      if (this.isCtrlPin) { // 若按著 ctrl
        this.checkItem(index, true)
        this.pinOrigin = index
      } else if (this.isShiftPin) { // 若按著 shift
        const start = Math.min(index, this.pinOrigin)
        const end = Math.max(index, this.pinOrigin)

        this.checkItem(false)
        for (let i = start; i <= end; i++) {
          this.$set(this.multipleCheckList, i, true)
        }
      } else {
        this.checkItem(index)
        this.pinOrigin = index
      }
    },
    onDraggableUpdate ({ oldIndex, newIndex }) {
      const list = [...this.multipleCheckList]
      if (newIndex > oldIndex) {
        list.splice(newIndex + 1, 0, list[oldIndex])
        list.splice(oldIndex, 1)
      } else {
        list.splice(newIndex, 0, list[oldIndex])
        list.splice(oldIndex + 1, 1)
      }
      this.multipleCheckList = list
    },
  },
  computed: {
    groupList () {
      if (!this.competition) return null
      const list = []
      for (const key in this.competition) {
        if (!['isPlaying', 'timestamp'].some(v => key === v)) list.push(key)
      }
      return list.sort((a, b) => a - b)
    },
    groupId () {
      return this.groupList ? this.groupList[this.selectedTab] || null : null
    },
    isLoading () {
      return !this.competition || this.isImporting || this.isSaving
    },
    formInfo () {
      return this.$store.state.formInfo
    },
    periodList () {
      const list = []
      for (const formKey in this.formInfo) { list.push(+formKey) }
      list.sort((a, b) => b.period - a.period)
      return list
    },
    levelList () {
      if (!this.importPeroid) return []
      const list = []
      for (const formKey in this.formInfo[this.importPeroid]) {
        list.push({ value: +formKey, text: this.$t(this.convertLevelText(formKey)) })
      }
      list.sort((a, b) => b.period - a.period)
      return list
    },
    isMobile () {
      return this.$vuetify.breakpoint.xs
    },
    checkedItemCount () {
      if (!this.competition) return null
      try {
        const totalLength = this.competition[this.groupId].length
        return this.multipleCheckList.every(_ => _) && this.multipleCheckList.length >= totalLength
          ? -1
          : this.multipleCheckList.filter(_ => _).length
      } catch (e) {
        return null
      }
    },
    isSomeMultipleChecked () {
      return this.checkedItemCount > 0 || this.checkedItemCount === -1
    },
    isMutlipleSelectionSnackBarShow () {
      const offsetTop = this.$store.state.offsetTop
      return this.isMobile && offsetTop > 170
    },
  },
  watch: {
    competition: {
      handler (newValue, oldValue) {
        if (oldValue && !this.isLoading) {
          this.isModified = true
          if (this.isAutoSubmit && !this.isFetching) this.submit()
        }
      },
      deep: true,
    },
    isAutoSubmit (newValue) {
      if (newValue && this.isModified) this.submit()
    },
    selectedTab () {
      this.multipleCheckList = []
    },
    multipleCheckList: {
      handler (_) {},
      deep: true,
    },
  },
  components: {
    draggable,
    Loader,
    ToolbarSaveContent,
    SnackbarSuccess,
    PageTitle,
    ReadonlyCheckbox,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang="sass">
input
  display: inline-block
  &.full
    width: 100%
  &.auto
    min-width: 1rem
    width: auto

.number
  color: #333
  font-weight: 600
  font-size: 1rem
  font-family: sans-serif

.list-item
  user-select: none
  .theme--dark &
    &.active
      background: hsla(0,0%,100%,.1)
      box-shadow: inset 0 0 1px hsla(0,0%,100%,.7)
  .theme--light &
    &.active
      background: rgba(0,0,0,.1)
      box-shadow: inset 0 0 1px rgba(0,0,0,.7)

.multiple-selection-bar
  .transition-group
    margin: 0
    display: flex
    align-items: center
    flex-wrap: wrap
    span, a, .v-btn
      display: inline-block
      white-space: nowrap
      transition: all .15s
      min-width: 0
      +mx(.25rem)
  &.toolbar
    display: flex
    flex-direction: column
.handle
  cursor: default
</style>
